<form kendoForm [formGroup]="entityForm" (ngSubmit)="onSubmit()" [cols]="7">
  <fieldset kendoFormFieldSet legend="{{ 'EntityTranslation.BaseData' | translate }}" [colSpan]="7" [cols]="7">
    <kendo-formfield [colSpan]="2">
      <kendo-label [for]="codeInput" text="{{ 'EntityTranslation.Code' | translate }}"></kendo-label>
      <kendo-textbox #codeInput formControlName="code"></kendo-textbox>
      @if (entityForm.controls.code.hasError('required') && entityForm.controls.code.touched) {
      <kendo-formerror>
        <span translate>Validation.Required</span>
      </kendo-formerror>
      }
      @if (entityForm.controls.code.hasError('maxlength') && entityForm.controls.code.touched) {
      <kendo-formerror>
        <span translate>EntityTranslation.EntityCodeLengthError</span>
      </kendo-formerror>
      }
    </kendo-formfield>
    <kendo-formfield [colSpan]="2">
      <kendo-label [for]="descriptionInput" text="{{ 'EntityTranslation.Description' | translate }}"></kendo-label>
      <kendo-textbox #descriptionInput formControlName="description"></kendo-textbox>
      @if (entityForm.controls.description.hasError('required') && entityForm.controls.description.touched) {
      <kendo-formerror>
        <span translate>Validation.Required</span>
      </kendo-formerror>
      }
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label [for]="baseUnitCodeInput" text="{{ 'EntityTranslation.BaseUnitCode' | translate }}"></kendo-label>
      <app-select-unit #baseUnitCodeInput formControlName="baseUnitCode"></app-select-unit>
      @if (entityForm.controls.baseUnitCode.hasError('required') && entityForm.controls.baseUnitCode.touched) {
      <kendo-formerror>
        <span translate>Validation.Required</span>
      </kendo-formerror>
      }
      @if (entityForm.controls.baseUnitCode.hasError('maxlength') && entityForm.controls.baseUnitCode.touched) {
      <kendo-formerror>
        <span translate>EntityTranslation.EntityCodeLengthError</span>
      </kendo-formerror>
      }
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label text="{{ 'EntityTranslation.State' | translate }}"></kendo-label>
      <app-select-entity-status formControlName="status"></app-select-entity-status>
      @if (entityForm.controls.status.hasError('required') && entityForm.controls.status.touched) {
      <kendo-formerror>
        <span translate>Validation.Required</span>
      </kendo-formerror>
      }
    </kendo-formfield>

    <kendo-formfield class="dimension-field">
      <kendo-label [for]="dimensionInput" text="{{ 'GluePlan.Dimension' | translate }}"></kendo-label>
      <kendo-dropdownlist #dimensionInput formControlName="beamLamminaDimensionId" [valuePrimitive]="true"
        [data]="dimensions" textField="description" valueField="beamLamminaDimensionID"
        [defaultItem]="noDimensionItem"></kendo-dropdownlist>
    </kendo-formfield>

    <app-machine-selector-dropdown formControlName="machineId"
      [machineGroupId]="_entityGroup?.machineGroupId"></app-machine-selector-dropdown>
    <kendo-formfield>
      <kendo-label [for]="batchTimeInput" text="{{ 'EntityTranslation.BatchTime' | translate }}"></kendo-label>
      <kendo-numerictextbox #batchTimeInput [min]="0" [maxlength]="5" [decimals]="0" [format]="'n0'"
        formControlName="batchTime">
        <ng-template kendoSuffixTemplate>
          <button kendoButton [disabled]="true" fillMode="clear">{{ 'Abbreviations.Minute' | translate }}</button>
        </ng-template>
      </kendo-numerictextbox>
      @if (entityForm.controls.batchTime.hasError('min') && (entityForm.controls.batchTime.touched ||
      entityForm.controls.batchTime.dirty)) {
      <kendo-formerror>
        <span translate>Validation.MinValue</span> 0
      </kendo-formerror>
      }
      @if (entityForm.controls.batchTime.hasError('max') && (entityForm.controls.batchTime.touched ||
      entityForm.controls.batchTime.dirty)) {
      <kendo-formerror>
        <span translate>Validation.MaxValue</span> 32767
      </kendo-formerror>
      }
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label [for]="batchSizeInput" text="{{ 'EntityTranslation.BatchSize' | translate }}"></kendo-label>
      <kendo-numerictextbox #batchSizeInput [decimals]="3" [format]="'n3'" [maxlength]="10" formControlName="batchSize">
        <ng-template kendoSuffixTemplate>
          <button kendoButton [disabled]="true" fillMode="clear">{{entityForm.controls.baseUnitCode.value}}</button>
        </ng-template>
      </kendo-numerictextbox>
      @if (entityForm.controls.batchSize.hasError('min') && (entityForm.controls.batchSize.touched ||
      entityForm.controls.batchSize.dirty)) {
      <kendo-formerror>
        <span translate>Validation.MinValue</span> 0
      </kendo-formerror>
      }
      @if (entityForm.controls.batchSize.hasError('max') && (entityForm.controls.batchSize.touched ||
      entityForm.controls.batchSize.dirty)) {
      <kendo-formerror>
        <span translate>Validation.MaxValue</span> 999999.999
      </kendo-formerror>
      }
    </kendo-formfield>
    <kendo-formfield [colSpan]="4">
      <kendo-label [for]="instructionInput" text="{{ 'EntityTranslation.Instruction' | translate }}"></kendo-label>
      <kendo-textarea #instructionInput formControlName="instruction" [rows]="3"></kendo-textarea>
    </kendo-formfield>
  </fieldset>

  <fieldset kendoFormFieldSet legend="{{ 'EntityTranslation.PropertyValues' | translate }}" [colSpan]="1">
    <div class="property-values-list" formArrayName="propertyValues">
      @for (v of propertyValues.controls; track v; let i = $index) {
      <kendo-formfield [formGroupName]="i" [orientation]="'horizontal'"
        [class.invalid-property]="isMandatoryPropertyInvalid(v)">
        <kendo-label [for]="prop">{{ getProperty(v.value.code).description }}</kendo-label>
        <app-select-valid-value #prop formControlName="value" [property]="getProperty(v.value.code)"
          [entityGroupIndex]="_entityGroup.index"></app-select-valid-value>
        @if (v.controls.value.hasError('required') && (v.controls.value.touched || v.controls.value.dirty)) {
        <kendo-formerror>
          <span translate>Validation.Required</span>
        </kendo-formerror>
        }
      </kendo-formfield>
      }
    </div>
  </fieldset>
  <fieldset kendoFormFieldSet legend="{{ 'EntityTranslation.Files' | translate }}" [colSpan]="1">
    @if (!isNew) {
    <app-file-upload [container]="'activity-attachments'" [folder]="entityForm.controls.guid.value"
      [downloadMode]="fileDownloadMode.SingleFileUsingChip"></app-file-upload>
    }
  </fieldset>
  <fieldset kendoFormFieldSet legend="{{ 'EntityTranslation.RelationActivity' | translate }}" [colSpan]="5">
    <kendo-grid class="entity-relation-table" [data]="entityRelationGridData" [scrollable]="'virtual'"
      [rowReorderable]="true" [loading]="loading" (rowReorder)="onRowReorder($event)">
      <ng-template kendoGridToolbarTemplate>
        <button kendoButton type="button" (click)="openAddEditGlulamSpecModal()" [primary]="true"
          [disabled]="!isGlulamSpecEnabled">
          {{ 'GluePlan.GlulamSpec' | translate }}
        </button>

        <kendo-grid-spacer></kendo-grid-spacer>

        <button kendoButton type="button" (click)="addNewEntityRelation()" [svgIcon]="plusIcon" [primary]="true"
          title="{{ 'App.Add' | translate }}"></button>
      </ng-template>
      <kendo-grid-rowreorder-column [width]="40"></kendo-grid-rowreorder-column>

      <kendo-grid-column field="sortOrder" [editable]="false" [width]="80" [filterable]="false"
        [title]="'EntityTranslation.SortOrder' | translate"></kendo-grid-column>

      <kendo-grid-column field="entityIndex" [title]="'EntityTranslation.Material' | translate" [width]="300">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [formGroup]="dataItem.relationGroup">
            <app-select-entity class="relation-entity-select"
              [class.readonly-entity-select]="!dataItem.relationGroup.controls.isNew?.value"
              formControlName="entityIndex" [entityTypeCode]="'RESOURCE'" [showLable]="false"
              (selectedEntity)="onEntityRelationEntitySelected($event, dataItem.formIndex)"></app-select-entity>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="relation" [title]="'EntityTranslation.Relation' | translate" [width]="130">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [formGroup]="dataItem.relationGroup"
            [class.invalid-hour-relation]="isRelationInvalid(dataItem.relationGroup)">
            <kendo-numerictextbox [decimals]="12" [format]="'n3'" formControlName="relation"></kendo-numerictextbox>
            @if (getRelationErrorKey(dataItem.relationGroup); as relationErrorKey) {
            <kendo-formerror>
              <span translate>{{ relationErrorKey }}</span>
            </kendo-formerror>
            }
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="unitCode" [title]="'App.UnitCode' | translate" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [formGroup]="dataItem.relationGroup">
            <app-select-unit formControlName="unitCode" [showLable]="false"></app-select-unit>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="direction" [title]="'App.Direction' | translate" [width]="125">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [formGroup]="dataItem.relationGroup"
            [class.invalid-direction-relation]="isDirectionInvalid(dataItem.relationGroup)">
            <app-select-entity-relation-direction formControlName="direction"></app-select-entity-relation-direction>
            @if (getDirectionErrorKey(dataItem.relationGroup); as directionErrorKey) {
            <kendo-formerror>
              <span translate>{{ directionErrorKey }}</span>
            </kendo-formerror>
            }
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="inTactical" [title]="'EntityTranslation.Tactical' | translate" [width]="60">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [formGroup]="dataItem.relationGroup">
            <kendo-switch formControlName="inTactical"></kendo-switch>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="inOperative" [title]="'EntityTranslation.Operative' | translate" [width]="60">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [formGroup]="dataItem.relationGroup">
            <kendo-switch formControlName="inOperative"></kendo-switch>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="isChaining" [title]="'EntityTranslation.Chaining' | translate" [width]="60">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [formGroup]="dataItem.relationGroup">
            <kendo-switch formControlName="isChaining"></kendo-switch>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="batchTemplateId" [title]="'Operative.BatchTemplate' | translate" [width]="260">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [formGroup]="dataItem.relationGroup">
            <app-select-batch-template formControlName="batchTemplateId"
              [machineId]="entityForm.controls.machineId?.value"
              [machineGroupId]="_entityGroup?.machineGroupId ?? null"></app-select-batch-template>
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [title]="''" [width]="70">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button kendoButton themeColor="error" type="button" [svgIcon]="minusIcon" [size]="'small'"
            (click)="removeEntityRelation(dataItem.formIndex)"></button>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </fieldset>
</form>
<kendo-dialog-actions layout="end">
  @if (isNew) {
  <button kendoButton type="submit" (click)="onSubmit()" [disabled]="!entityForm.valid || disableSubmit"
    [primary]="true">
    {{ 'App.Add' | translate }}
  </button>
  } @if (!isNew) {
  <button kendoButton type="submit" [disabled]="!entityForm.valid || disableSubmit" (click)="onSubmit()"
    [primary]="true">
    {{ 'App.Update' | translate }}
  </button>
  }
</kendo-dialog-actions>

@if (confirmRemoveRelationIndex !== null) {
<app-confirmation-dialog (conformationDialogCloseEvent)="confirmEntityRelationRemoval($event)"
  [msg]="confirmEntityRelationRemovalMsg()"></app-confirmation-dialog>
}
